// @flow
import React from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  img: string,
  title: string,
  description: string,
  label: string,
  link: string,
  img: string,
  small?: boolean,
  containerStyle?: string,
  sidebar?: boolean
};

const HubCard = (props: Props) => {
  const { img, title, description, link, label, small, containerStyle, sidebar } = props;

  const classNamesCardContainer = dynamicClassName('box card card--hub');
  small && classNamesCardContainer.add('card--small');
  containerStyle && classNamesCardContainer.add(containerStyle);
  sidebar && classNamesCardContainer.add('card--small mb-4 mb-md-5');
  return (
    <Link to={link} title={`En savoir plus sur ${title}`} className={classNamesCardContainer.build()}>
      <div className="card__thumbnail img-blue" style={{ backgroundImage: `url(${img})` }} />
      <div className="card__body">
        <h3 className="card__title ft-h2">{title}</h3>
        <p className="card__desc ft-secondary">{description}</p>
      </div>
      <div className="card__footer">
        <span to={link} className="btn btn--cheer">
          <i className="icon icon-chevron-right link-icon is-dark is-inline" />
          <span>{label}</span>
        </span>
      </div>
    </Link>
  );
};

export default HubCard;
